import React from 'react';
import { useTranslation } from 'react-i18next';
import { SupporterDetailsPlaceholder } from '../index';
import PageSection from '../PageSection/PageSection';
import { SkeletonProps } from '../../interfaces/SkeletonProps';
import Refresh from '../Refresh/Refresh';

const SupportersListSkeleton: React.FunctionComponent<SkeletonProps> = ({
  animated,
  onRefresh,
  displayRefreshButton,
}) => {
  const { t } = useTranslation('common', { useSuspense: false });

  return (
    <PageSection title={t('supporters.title')} hasBorder>
      <Refresh
        onRefresh={onRefresh}
        displayRefreshButton={displayRefreshButton}
        buttonLabel={t('supporters.refresh')}
      >
        <SupporterDetailsPlaceholder animated={animated} />
      </Refresh>
    </PageSection>
  );
};

export default SupportersListSkeleton;
